import AssistantCitationAPIResponse from "ai-assistant/api/response-contracts/assistant-citation-api-response";
import AssistantCitation from "ai-assistant/values/assistant-citation";
import AssistantResponse, { Role } from "ai-assistant/values/assistant-response";
import Date from "common/values/date/date";
import moment from "moment";

export default class AssistantAPIResponse {
  public responseId?: string;
  public role?: string;
  public text?: string;
  public citations?: AssistantCitationAPIResponse[];
  public timestamp?: string;

  public deserialize(): AssistantResponse {
    if (!this.role) {
      throw new Error("Invalid AssistantAPIResponse: role must be defined");
    }
    if (!this.text ) {
      throw new Error("Invalid AssistantAPIResponse: text must be defined");
    }
    if (!this.timestamp) {
      throw new Error("Invalid AssistantAPIResponse: timestamp must be defined");
    }

    let citations: AssistantCitation[] = [];

    for (const citation of this.citations ?? []) {
      citations.push(Object.assign(
        new AssistantCitationAPIResponse(),
        citation
      ).deserialize());
    }

    return new AssistantResponse(
      this.responseId, 
      this.role as Role,
      this.text,
      citations,
      new Date(moment(this.timestamp))
    );
  }
}
